
import React, { useState, useEffect} from "react";
import { Button, Card, Col, Row, Form, InputGroup } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import {
  getIssuesList,
  createTicket,
  createOtherIssue,
} from "../../Service/AllTicketServiceAPI";
import { getRoLiveSearch } from "../../Service/AllRoOnboardingAPI";


import issueOptions from "./issueOptions.json";
import {

  getDispenserSrNoList,

} from "../master/AllUserDropDown";

import {
  getDispenserDropDownListForCalibration,

} from "../../Service/AllWorkOrderCalibrationAPI";

import {
  getDispenserDropDownListForFieldJob,

} from "../../Service/AllWorkOrderFieldIssueAPI";





const TicketForm = () => {

  // const [issuesList, setIssuesList] = useState(
  //   (issueOptions || [])
  //     .map((it) => ({
  //       id: Number(it.id),
  //       label: it.label,
  //       priority: it.priority || null,
  //     }))
  //     .sort((a, b) => a.label.localeCompare(b.label))
  // );

  const [issuesList, setIssuesList] = useState([]);
  const [customIssueInput, setCustomIssueInput] = useState("");
  const [customPriority, setCustomPriority] = useState("");

  const [installationDispensers, setInstallationDispensers] = useState([]);
  const [calibrationDispensers, setCalibrationDispensers] = useState([]);
  const [fieldJobDispensers, setFieldJobDispensers] = useState([]);
  const [unassignedDispensers, setUnassignedDispensers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [roSearchOptions, setRoSearchOptions] = useState([]);
  const [roSearchLoading, setRoSearchLoading] = useState(false);
  const [activeSearchType, setActiveSearchType] = useState("");
  const [issueSearch, setIssueSearch] = useState("");
  const [customotpType, setCustomotpType] = useState("");






  const initialValues = {
    jobType: "",
    ticketType: "NON_SLA",
    roName: "",
    roCode: "",
    roAddress: "",
    roCity: "",
    roState: "",
    roDistrict:"",
    roCountry: "India",
    roContact: "",
    roEmail: "",
    roSiteType:"",
    dispenserSrNo: "",
    assignedTechUsername: "",
    roManagerUsername: "",
    issueIds: [],
    pincode: "",
   seId: "",
  seName: "",
  seEmail: "",
  seContactNumber: "",
  remarkByNonTech:"",
   pkUserId: "", 
  };

  const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$";
  const validationSchema = Yup.object({
    jobType: Yup.string().required("Job type is required"),
    remarkByNonTech: Yup.string().required("Enter nontech remark"),

    dispenserSrNo: Yup.string().required("Dispenser Sr No is required"),

      issueIds: Yup.array()
    .of(Yup.number())
    .length(1, "Please select exactly one issue")
    .required("Issue is required"),
  });
  


  const MIN_CHARS = 1;
  let searchTimeout;

  const handleLiveSearch = (type, value, setFieldValue) => {
    clearTimeout(searchTimeout);

    if (!value || value.trim() === "") {
      setFieldValue("roName", "");
      setFieldValue("roCode", "");
      setFieldValue("roAddress", "");
      setFieldValue("roCity", "");
      setFieldValue("roState", "");
      setFieldValue("roCountry", "India");
      setFieldValue("roContact", "");
      setFieldValue("roEmail", "");
      setFieldValue("pincode", "");
      setFieldValue("contactPerson", "");
      setFieldValue("roSiteType", "");
      setFieldValue("dispenserSrNo", "");

      setUnassignedDispensers([]);
      setRoSearchOptions([]);
      return;
    }

    if (value.length < MIN_CHARS) return;

    searchTimeout = setTimeout(async () => {
      try {
        const res = await getRoLiveSearch({
          roCode: type === "roCode" ? value : "",
          roName: type === "roName" ? value : "",
          roContact: type === "roContact" ? value : "",
          roEmail: type === "roEmail" ? value : "",
          contactPerson: type === "contactPerson" ? value : "",
        });

        const data = res.data || [];

        setRoSearchOptions(data);

        const exactMatch = data.find((ro) => {
          switch (type) {
            case "roCode":
              return ro.roCode?.toLowerCase() === value.toLowerCase();
            case "roName":
              return ro.roName?.toLowerCase() === value.toLowerCase();
            case "contactPerson":
              return ro.contactPerson?.toLowerCase() === value.toLowerCase();

            case "roContact":
              return ro.roContact === value;
            case "roEmail":
              return ro.roEmail?.toLowerCase() === value.toLowerCase();
            default:
              return false;
          }
        });

        if (!exactMatch) {

          setFieldValue("roAddress", "");
          setFieldValue("roCity", "");
          //  setFieldValue("roName", "");
          setFieldValue("roState", "");
          setFieldValue("roCountry", "");
          setFieldValue("roDistrict", "");
          // setFieldValue("roContact", "");
          // setFieldValue("roEmail", "");
          setFieldValue("pincode", "");
          // setFieldValue("contactPerson", "");
          setFieldValue("roSiteType", "");
          setFieldValue("dispenserSrNo", "");

          setUnassignedDispensers([]);
          return;
        }


        setFieldValue("roName", exactMatch.roName || "");
        setFieldValue("roCode", exactMatch.roCode || "");
        setFieldValue("roAddress", exactMatch.address || "");
        setFieldValue("roCity", exactMatch.city || "");
        setFieldValue("roDistrict", exactMatch.roDistrict || "");
        setFieldValue("roState", exactMatch.state || "");
        setFieldValue("roCountry", exactMatch.country || "India");
        setFieldValue("roContact", exactMatch.roContact || "");
        setFieldValue("roEmail", exactMatch.roEmail || "");
        setFieldValue("pincode", exactMatch.pincode || "");
        setFieldValue("contactPerson", exactMatch.contactPerson || "");
        setFieldValue("roSiteType", exactMatch.roSiteType || "");

        const dispensers =
          exactMatch.dispensers?.map((d) => ({
            value: d.dispenserNumber,
            label: d.dispenserNumber,
          })) || [];
        setActiveSearchType(type);
        setRoSearchOptions(data);

        setUnassignedDispensers(dispensers);
        setFieldValue("dispenserSrNo", "");
      } catch (err) {
        console.error("RO search failed", err);
      }
    }, 300);
  };

const filteredIssues = issuesList.filter((issue) =>
  issue.label.toLowerCase().includes(issueSearch.toLowerCase())
);

const fetchIssuesList = async () => {
  try {
    const res = await getIssuesList();

    const formatted = (res.data || [])
      .map((it) => ({
        id: Number(it.issueId),
        label: it.partName,
        priority: it.priority,
        otpType: it.jobType // OTP / NON_OTP from backend
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    setIssuesList(formatted);
  } catch (err) {
    console.error("Issue list fetch failed", err);
  }
};


  const handleSubmit = async (values, { resetForm }) => {
    try {

      setIsSubmitting(true);
      const token = sessionStorage.getItem("token");


      const payloadTicket = {
        jobType: values.jobType,
        ticketType: values.ticketType,
        roName: values.roName,
        roCode: values.roCode,
        roAddress: values.roAddress,
        roCity: values.roCity,
        roState: values.roState,
        roDistrict: values.roDistrict,
        pincode: values.pincode,
        contactPerson:values.contactPerson,
        roCountry: values.roCountry,
        roContact: values.roContact,
        roEmail: values.roEmail,
        roSiteType:values.roSiteType,
        dispenserSrNo: values.dispenserSrNo,
        assignedTechUsername: values.assignedTechUsername,
        roManagerUsername: values.contactPerson,
        pkUserId: values.pkUserId,
        issueIds: values.issueIds,
        seId: values.seId,
        seName: values.seName,
        seEmail: values.seEmail,
        seContactNumber: values.seContactNumber,
        remarkByNonTech:values.remarkByNonTech,
      };

      await createTicket(payloadTicket);

      swal("Success", "Ticket raised successfully!", "success");
      resetForm();
    } catch (err) {
      console.error("Create ticket failed:", err);
      swal("Failed", "Failed to raise ticket.", "warning");
    }
    finally {
      setIsSubmitting(false);
    }

  };

  useEffect(() => {
    fetchInstallationDispensers();
     fetchIssuesList();
    fetchCalibrationDispensers();
    fetchFieldJobDispensers();
  }, []);


  const fetchInstallationDispensers = async () => {
    try {
      const result = await getDispenserSrNoList();
      const list = result.map((item) =>
        typeof item === "object" ? item.value || item.label : item
      );
      setInstallationDispensers(list);
    } catch (err) {
      console.error("Installation dispenser fetch failed", err);
    }
  };

  const fetchCalibrationDispensers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const result = await getDispenserDropDownListForCalibration(headers);

      if (result?.data?.length) {
        setCalibrationDispensers(
          result.data.map((d) => ({ value: d, label: d }))
        );
      }
    } catch (err) {
      console.error("Calibration dispenser fetch failed", err);
    }
  };


  const fetchFieldJobDispensers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const result = await getDispenserDropDownListForFieldJob(headers);

      if (result?.data?.length) {
        const tempDispenserArray = result.data
          .map((no) => ({
            value: `${no}`,
            label: `${no}`,
          }))
          .reverse();

        setFieldJobDispensers(tempDispenserArray);

        console.log("Field Job Dispensers:", tempDispenserArray);
      }
    } catch (error) {
      console.log("getDispenserDDLFFieldJob error :-", error);
    }
  };




  return (
    
    <>
      <Row>
        <h5 className="head text-center">Raise Ticket Form</h5>
      </Row>

      <div className="d-flex">
        <Link to="TicketServiceNonTech" className="fieldLink btn btn-primary">
          <FontAwesomeIcon icon={faAngleLeft} className="me-2" />
          Back
        </Link>
      </div>

      <Card className="p-4 mt-4" style={{ margin: "0 auto" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isValid, dirty }) => {
            
          
            
        
            const addCustomIssue = async () => {
              const text = customIssueInput.trim();
              

              if (!text) {
                swal("Error", "Please enter issue name", "warning");
                return;
              }

              if (!customPriority) {
                swal("Error", "Please select priority", "warning");
                return;
              }

              if (!customotpType) {
                swal("Error", "Please select OTP Type (OTP / NON-OTP)", "warning");
                return;
              }
              
              try {
                // server expects array of issues; send one item
                const payload = [
                  {
                    partName: text,
                    priority: customPriority,
                    otpType: customotpType 
                  }
                ];
                
                const res = await createOtherIssue(payload);
                
                
                const createdArray = Array.isArray(res.data) ? res.data : [res.data];
                if (!createdArray || createdArray.length === 0) {
                  throw new Error("No issue returned from server");
                }
                
                const created = createdArray[0];
                
                // Convert ID to number for consistency
                const createdId = Number(created.issueId);
                
                const newIssue = {
                  id: createdId,
                  label: created.partName || text,
                  priority: created.priority || customPriority,
                  otpType: created.otpType
                };
                
                // Avoid duplicates: if same id already exists, skip adding to issuesList
                setIssuesList((prev) => {
                  const exists = prev.some((it) => Number(it.id) === createdId);
                  if (exists) return prev;
                  return [...prev, newIssue];
                });
                
                // Auto-select the newly created issue (ensure numeric)
                const currentlySelected = Array.isArray(values.issueIds)
                ? values.issueIds.map((id) => Number(id))
                : [];
                setFieldValue("issueIds", [createdId]);
                setFieldValue("jobType", "Field Job");
                
                
                // Clear input
                setCustomIssueInput("");
              } catch (err) {
                console.error("Custom Issue Create Failed:", err);
                swal("Failed", "Unable to add custom issue.", "warning");
              }
            };
            


            // const toggleIssue = (issueId) => {
            //   const idNum = Number(issueId);


            //   if (values.issueIds?.includes(idNum)) {
            //     setFieldValue("issueIds", []);
            //     setFieldValue("jobType", "");
            //     setFieldValue("dispenserSrNo", "");
            //     return;
            //   }


            //   setFieldValue("issueIds", [idNum]);
            //   // setFieldValue("dispenserSrNo", "");

            //   if (idNum === 4) {
            //     setFieldValue("jobType", "Installation");
            //   } else if (idNum === 3) {
            //     setFieldValue("jobType", "Calibration");
            //   } else {
            //     setFieldValue("jobType", "Field Job");
            //   }
            // };


            const toggleIssue = (issueId) => {
              const idNum = Number(issueId);

              if (values.issueIds.includes(idNum)) {
                setFieldValue("issueIds", []);
                setFieldValue("jobType", "");
                setFieldValue("dispenserSrNo", "");
                setIssueSearch(""); // clear search
                return;
              }

              const selectedIssue = issuesList.find(
                (it) => Number(it.id) === idNum
              );

              setFieldValue("issueIds", [idNum]);
              setFieldValue("jobOtpType", selectedIssue.otpType);

                setIssueSearch(selectedIssue?.label || "");

              if (idNum === 4) {
                setFieldValue("jobType", "Installation");
              } else if (idNum === 3) {
                setFieldValue("jobType", "Calibration");
              } else {
                setFieldValue("jobType", "Field Job");
              }
            };


            const fillRO = (ro, setFieldValue) => {
              setFieldValue("roName", ro.roName || "");
              setFieldValue("roCode", ro.roCode || "");
              setFieldValue("roAddress", ro.address || "");
              setFieldValue("roCity", ro.city || "");
              setFieldValue("roState", ro.state || "");
              setFieldValue("roDistrict", ro.district || "");
              setFieldValue("roCountry", ro.country || "India");
              setFieldValue("roContact", ro.roContact || "");
              setFieldValue("roEmail", ro.roEmail || "");
              setFieldValue("pincode", ro.pincode || "");
              setFieldValue("contactPerson", ro.contactPerson || "");
              setFieldValue("roSiteType", ro.roSiteType || "");
            setFieldValue("seId", ro.serviceEngineer?.seId || "");
            setFieldValue("seName", ro.serviceEngineer?.seName || "");
            setFieldValue("seEmail", ro.serviceEngineer?.seEmail || "");
            setFieldValue("seContactNumber", ro.serviceEngineer?.seContactNumber || "");
              setFieldValue("pkUserId", ro.pkUserId || "");

              const dispensers =
                ro.dispensers?.map((d) => ({
                  value: d.dispenserNumber,
                  label: d.dispenserNumber,
                })) || [];

              setUnassignedDispensers(dispensers);
              setFieldValue("dispenserSrNo", "");

              setRoSearchOptions([]);
              setActiveSearchType("");
            };

        
            
            return (
              <FormikForm>
                      
                <Row>


                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="LabelNew">Select Issues *</Form.Label>

                 
                      <Form.Control
                        type="text"
                        placeholder="Search by issue name..."
                        value={issueSearch}
                        disabled={values.issueIds.length === 1}
                        onChange={(e) => setIssueSearch(e.target.value)}
                        className="mb-2"
                      />

                   
                      <div
                        style={{
                          maxHeight: "180px",
                          overflowY: "auto",
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "4px",
                        }}
                      >
                        {filteredIssues.length === 0 && (
                          <div className="text-muted small">No matching issues found</div>
                        )}

                        {filteredIssues.map((issue) => (
                          <div key={issue.id} className="form-check mb-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`issue-${issue.id}`}
                              checked={values.issueIds.includes(Number(issue.id))}
                              onChange={() => toggleIssue(issue.id)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`issue-${issue.id}`}
                            >
                              {issue.label}
                            </label>
                          </div>
                        ))}
                      </div>

                     
                      {/* <div className="mt-3">
                        <InputGroup>
                          <Form.Control
                            type="text"
                            placeholder="Enter other issue"
                            value={customIssueInput}
                            onChange={(e) => setCustomIssueInput(e.target.value)}
                          />

                          <Form.Select
                            style={{ maxWidth: "130px" }}
                            value={customPriority}
                            onChange={(e) => setCustomPriority(e.target.value)}
                          >
                            <option value="HIGH">HIGH</option>
                            <option value="MEDIUM">MEDIUM</option>
                            <option value="LOW">LOW</option>
                          </Form.Select>

                          <Button variant="success" onClick={addCustomIssue}>
                            Add
                          </Button>
                        </InputGroup>
                      </div> */}

                     {values.issueIds.length === 0 && (
                      <div className="mt-3">
                        <InputGroup>
                          <Form.Control
                            type="text"
                            placeholder="Enter other issue"
                            value={customIssueInput}
                            
                            onChange={(e) => setCustomIssueInput(e.target.value)}
                          />

                          {/* Priority */}
                          <Form.Select
                            style={{ maxWidth: "110px" }}
                            value={customPriority}
                            onChange={(e) => setCustomPriority(e.target.value)}
                          >
                            <option value="">Priority</option>
                            <option value="HIGH">HIGH</option>
                            <option value="MEDIUM">MEDIUM</option>
                            <option value="LOW">LOW</option>
                          </Form.Select>

                          {/*  JobType (OTP / NON_OTP) */}
                          <Form.Select
                            style={{ maxWidth: "164px" }}
                            value={customotpType}
                            onChange={(e) => setCustomotpType(e.target.value)}
                          >
                            <option value="">Select OTP Type</option>
                            <option value="NON_OTP">NON-OTP</option>
                            <option value="OTP">OTP</option>
                          </Form.Select>

                          <Button variant="success" onClick={addCustomIssue}>
                            Add
                          </Button>
                        </InputGroup>
                      </div>


)}
                      <ErrorMessage
                        name="issueIds"
                        component="div"
                        className="text-danger small mt-1"
                      />
                    </Form.Group>
                  </Col>





                  <Col md={6}></Col>

                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="LabelNew">RO Code *</Form.Label>
                      <Form.Control
                        type="text"
                        value={values.roCode}
                        placeholder="Type RO Code"
                        onChange={(e) => {
                          setActiveSearchType("roCode");
                          setFieldValue("roCode", e.target.value);
                          handleLiveSearch("roCode", e.target.value, setFieldValue);
                        }}
                      />

                      {/* RO CODE SUGGESTIONS */}
                      {activeSearchType === "roCode" && roSearchOptions.length > 0 && (
                        <ul className="list-group mt-1">
                          {roSearchOptions.map((ro) => (
                            <li
                              key={ro.roCode}
                              className="list-group-item list-group-item-action"
                              onClick={() => fillRO(ro, setFieldValue)}
                            >
                              <strong>{ro.roCode}</strong> — {ro.roName}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Form.Group>
                  </Col>


                 

                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="LabelNew">RO Name *</Form.Label>
                      <Form.Control
                        type="text"
                        value={values.roName}
                        placeholder="Type RO Name"
                        onChange={(e) => {
                          setActiveSearchType("roName");
                          setFieldValue("roName", e.target.value);
                          handleLiveSearch("roName", e.target.value, setFieldValue);
                        }}
                      />

                      {/*  RO NAME SUGGESTIONS */}
                      {activeSearchType === "roName" && roSearchOptions.length > 0 && (
                        <ul className="list-group mt-1">
                          {roSearchOptions.map((ro) => (
                            <li
                              key={ro.roCode}
                              className="list-group-item list-group-item-action"
                              onClick={() => fillRO(ro, setFieldValue)}
                            >
                              <strong>{ro.roName}</strong> — {ro.roCode}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="LabelNew">Select Dispenser *</Form.Label>

                      <Select
                        name="dispenserSrNo"
                        placeholder="Please Select Dispenser"
                        options={unassignedDispensers}   
                        value={
                          unassignedDispensers.find(
                            (d) => d.value === values.dispenserSrNo
                          ) || null
                        }
                        onChange={(selected) => {
                          setFieldValue("dispenserSrNo", selected?.value || "");
                        }}
                        isClearable
                      />

                      <ErrorMessage
                        name="dispenserSrNo"
                        component="div"
                        className="text-danger small"
                      />
                    </Form.Group>
                  </Col>

    

                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="LabelNew">RO Manager Name *</Form.Label>
                      <Form.Control
                        type="text"
                        value={values.contactPerson}
                        placeholder="Type RO Manager Name"
                        // onChange={(e) => {
                        //   setFieldValue("contactPerson", e.target.value);
                        //   handleLiveSearch("contactPerson", e.target.value, setFieldValue);
                        // }}
                        onChange={(e) => {
                          setActiveSearchType("contactPerson");
                          setFieldValue("contactPerson", e.target.value);
                          handleLiveSearch("contactPerson", e.target.value, setFieldValue);
                        }}

                      />
                      {activeSearchType === "contactPerson" && roSearchOptions.length > 0 && (
                        <ul className="list-group mt-1">
                          {roSearchOptions.map((ro) => (
                            <li
                              key={ro.roCode}
                              className="list-group-item list-group-item-action"
                              onClick={() => fillRO(ro, setFieldValue)}
                            >
                              <strong>{ro.contactPerson}</strong> — {ro.roName}
                            </li>
                          ))}
                        </ul>
                      )}

                    </Form.Group>
                  </Col>



                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="LabelNew">RO Manager Contact Number *</Form.Label>
                      <Form.Control
                        type="text"
                        value={values.roContact}
                        placeholder="Type RO Contact Number"
                        // onChange={(e) => {
                        //   setFieldValue("roContact", e.target.value);
                        //   handleLiveSearch("roContact", e.target.value, setFieldValue);
                        // }}
                        onChange={(e) => {
                          setActiveSearchType("roContact");
                          setFieldValue("roContact", e.target.value);
                          handleLiveSearch("roContact", e.target.value, setFieldValue);
                        }}

                      />
                      {activeSearchType === "roContact" && roSearchOptions.length > 0 && (
                        <ul className="list-group mt-1">
                          {roSearchOptions.map((ro) => (
                            <li
                              key={ro.roCode}
                              className="list-group-item list-group-item-action"
                              onClick={() => fillRO(ro, setFieldValue)}
                            >
                              <strong>{ro.roContact}</strong> — {ro.roName}
                            </li>
                          ))}
                        </ul>
                      )}

                    </Form.Group>
                  </Col>

             
                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="LabelNew">RO Manager Email *</Form.Label>
                      <Form.Control
                        type="text"
                        value={values.roEmail}
                        placeholder="Type RO Manager Email"
                        // onChange={(e) => {
                        //   setFieldValue("roEmail", e.target.value);
                        //   handleLiveSearch("roEmail", e.target.value, setFieldValue);
                        // }}
                        onChange={(e) => {
                          setActiveSearchType("roEmail");
                          setFieldValue("roEmail", e.target.value);
                          handleLiveSearch("roEmail", e.target.value, setFieldValue);
                        }}

                      />

                      {activeSearchType === "roEmail" && roSearchOptions.length > 0 && (
                        <ul className="list-group mt-1">
                          {roSearchOptions.map((ro) => (
                            <li
                              key={ro.roCode}
                              className="list-group-item list-group-item-action"
                              onClick={() => fillRO(ro, setFieldValue)}
                            >
                              <strong>{ro.roEmail}</strong> — {ro.roName}
                            </li>
                          ))}
                        </ul>
                      )}

                    </Form.Group>
                  </Col>
                  
                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>Service Engineer Name</Form.Label>
                      <Field name="seName" className="form-control" disabled />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>Service Engineer Contact Number </Form.Label>
                      <Field name="seContactNumber" className="form-control" disabled />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>Service Engineer Email</Form.Label>
                      <Field name="seEmail" className="form-control" disabled />
                    </Form.Group>
                  </Col>


                     <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>RO SiteType</Form.Label>
                      <Field name="roSiteType" className="form-control" autoComplete="off" disabled />
                      <ErrorMessage name="roSiteType" component="div" className="text-danger small" />
                    </Form.Group>
                  </Col>


             
                 <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>RO Pincode</Form.Label>
                      <Field name="pincode" className="form-control" autoComplete="off" disabled />
                    </Form.Group>
                  </Col>

                    <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>Country</Form.Label>
                      <Field name="roCountry" className="form-control" autoComplete="off" disabled/>
                    </Form.Group>
                  </Col>

                     <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>State</Form.Label>
                      <Field name="roState" className="form-control" autoComplete="off" disabled />
                    </Form.Group>
                  </Col>

                   <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>District</Form.Label>
                      <Field name="roDistrict" className="form-control" autoComplete="off" disabled />
                    </Form.Group>
                  </Col>
                
               
                  <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label>RO Address</Form.Label>
                      <Field name="roAddress" className="form-control" autoComplete="off"  disabled/>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="LabelNew">
                        Non Tech Remark *
                      </Form.Label>

                      <Field
                        as="textarea"
                        name="remarkByNonTech"
                        className="form-control"
                        rows={3}
                        placeholder="Enter non technical remark here"
                      />

                      <ErrorMessage
                        name="remarkByNonTech"
                        component="div"
                        className="text-danger small mt-1"
                      />
                    </Form.Group>
                  </Col>


              {/* <Col md={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="LabelNew">Job Type *</Form.Label>
                      <Field name="jobType" as="select" className="form-control"   disabled>
                        <option value="">Job Type</option>
                        <option value="Unassigned">Unassigned</option>
                        <option value="Installation">Installation</option>
                        <option value="Calibration">Calibration</option>
                        <option value="Field Job">Field Job</option>
                      </Field>
                      <ErrorMessage
                        name="jobType"
                        component="div"
                        className="text-danger small"
                      />
                    </Form.Group>
                  </Col> */}


                </Row>

                <Button
                  type="submit"
                  variant="primary"
                  size="sm"
                  disabled={
                    isSubmitting ||
                    !isValid ||
                    !dirty ||
                    !values.issueIds ||
                    values.issueIds.length !== 1
                  }
                  className="mt-3"
                >
                  {isSubmitting ? "Please wait..." : "Submit Ticket"}
                </Button>


              </FormikForm>
            );
          }}
        </Formik>
      </Card>
    </>
  );
};

export default TicketForm;















